<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.search.fee_status" placeholder="费用状态">
                    <el-option :value="1" label="未提交"></el-option>
                    <el-option :value="2" label="已提交"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.processing_no" placeholder="加工单号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.plant_id" placeholder="加工厂" @visible-change="getPlant">
                    <el-option v-for="(list,index) in plantList" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-input class="search_input search_inputBox" v-model="params.plant_name" placeholder="加工厂"></el-input> -->
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.batch_no" placeholder="批次号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.ship_no" placeholder="船名" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                    <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList()">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batchEdit">批量修改</el-button> -->
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="confirmExamine">提交审核</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="processing.settlement.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">原木:{{totalObj.wood_cube}}</div>
                <div class="totalNumber">湿板:{{totalObj.wet_cube}}</div>
                <div class="totalNumber">干板{{totalObj.dry_cube}}</div>
                <div class="totalNumber">三角料:{{totalObj.triangle_total}}</div>
                <div class="totalNumber">费用{{totalObj.amount}}</div>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.settlement.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag :visible.sync="settlementDialog" class="eldialog eldialogMachSettlement" width="560px" :modal="false" :title="'加工费用详情('+settlementDetail.processing_no+')'" custom-class="full_dialog">
            <div class="diaTop clearfix">
                <div class="topTitle">加工日期:{{settlementDetail.processing_time | dateFormat}}</div>
                <div class="topTitle">加工厂:{{settlementDetail.plant_name}}</div>
                <div class="topTitle">加工类型:{{settlementDetail.processing_type_text}}</div>
                <div class="topTitle"><el-checkbox v-model="settlementDetail.is_invoice">是否提供发票</el-checkbox></div>
            </div>
            <el-table :data="settlementDetail.fee_list" border stripe highlight-current-row show-summary size="mini" height="100%">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="费用名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="品名" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.breed }}
                    </template>
                </el-table-column>
                <el-table-column label="数量" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.cube }}
                    </template>
                </el-table-column>
                <el-table-column label="单价" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.price }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="打包费" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.pack_amount }}
                    </template>
                </el-table-column>
                <el-table-column label="运费" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.freight_amount }}
                    </template>
                </el-table-column>
                <el-table-column label="堆存费" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.stack_amount }}
                    </template>
                </el-table-column>
                <el-table-column label="翻堆费" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.turn_amount }}
                    </template>
                </el-table-column>
                <el-table-column label="其他费用" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.other_amount }}
                    </template>
                </el-table-column> -->
                <el-table-column label="金额" prop="amount" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.amount }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn dialogBtn funcPublicBtnChecked" @click="confirm">提交审核</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="settlementDialog=!settlementDialog">取消</el-button>
            </div>
        </el-dialog>
        <!--修改 START -->
        <el-dialog v-dialog-drag title="费用调整" :visible.sync="editDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="editForm" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="堆存费：">
                        <el-input v-model="editForm.stack_amount" ></el-input>
                    </el-form-item>
                    <el-form-item label="翻堆费：">
                        <el-input v-model="editForm.turn_amount" ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="editDialog=!editDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="confirmEdit">确定</el-button>
            </div>
        </el-dialog>
        <!--修改 END -->
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:18px; font-weight:bold; line-height:25px; color: #333333;padding-bottom:20px;}
    .diaTop{padding:10px 0;}
    .topTitle{font-size: 12px;color:#333;float: left;margin-right:15px;}
    .dialogBtnList{padding:15px 0;}
</style>
<script>
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                start_time:"",
                end_time:"",
                module:localStorage.dw_erp_power_code,
                settlementDialog:false,
                editDialog:false,
                settlementDetail:{
                    fee_list:[],
                    plant_name: "",
                    processing_no: "",
                    processing_time: "",
                    total_amount: "",
                    is_invoice:false
                },
                editForm:{
                    id:"",
                    stack_amount:"",
                    turn_amount:"",
                },
                selectList:[],
                selectMap:{
                    plantList:[]
                },
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        processing_no:"",
                        fee_status:"",
                        plant_name:"",
                        plant_id:"",
                        contract_no:"",
                        batch_no:"",
                        ship_no:"",
                        breed_id:"",
                    },
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2单条，3多条
                list : [],
                // dialog START
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[
                    // {colName:"状态",colKey:"status_text",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用状态",colKey:"fee_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"加工单号",colKey:"processing_no",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"加工日期",colKey:"processing_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"干板件数",colKey:"dry_wood_count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"干板方数",colKey:"dry_wood_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成材率",colKey:"outturn_rate",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"缩水方数",colKey:"shrink_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"缩水率",colKey:"shrink_rate",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"原木方数",colKey:"wood_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锯板单价",colKey:"cut_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锯板金额",colKey:"cut_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"薄板方数",colKey:"thin_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"薄板单价",colKey:"thin_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"薄板费金额",colKey:"thin_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"湿板方数",colKey:"wet_wood_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"烘干单价",colKey:"drying_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"烘干金额",colKey:"drying_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"运费",colKey:"freight_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"打包费",colKey:"pack_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆存费",colKey:"stack_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"翻堆费",colKey:"turn_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"其他费用",colKey:"other_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合计加工费",colKey:"processing_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                // dialog END
                totalObj:{},
                breedList:[],
                plantList:[]
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            confirmEdit(){
                this.postFuncLoading("/erp/processing.field.settlement",this.editForm,()=>{
                    this.tip("修改成功","success")
                    this.editDialog = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPlant(){
                this.postFunc("/erp/processing.plants",{},res=>{
                    this.plantList=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBreed(){
                this.postFunc("/erp/processing.dry.breed",{},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            confirm(){
                let invoice = this.settlementDetail.is_invoice?1:0;
                this.postFuncLoading("/erp/processing.settlement.submit",{processing_id:this.settlementDetail.id,is_invoice:invoice},()=>{
                    this.getList()
                    this.tip("提交成功","success")
                    this.settlementDialog = false;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            confirmExamine(){
                let flag = true;
                if(this.selectList.length>0&&this.selectList.length<2){
                    // this.selectList.forEach(item=>{
                    //     if(!item.isEdit){
                    //         flag = false;
                    //         this.tip("选中内容有不可修改项","warning")
                    //     }
                    // })
                    if(flag){
                        this.postFuncLoading("/erp/processing.settlement.fee",{processing_id:this.selectList[0].id},res=>{
                            this.settlementDetail = res.data.data;
                            this.settlementDetail.id = this.selectList[0].id;
                            this.settlementDialog = true;
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }
                }else{
                    this.tip("请选择一条内容","warning")
                }
            },
            filterConfirm(){
                this.getList()
            },
            reset(){
                this.params={search:{start_time:"",end_time:"",fee_status:"",processing_no:"",plant_name:"",plant_id:"",contract_no:"",batch_no:"",ship_no:"",breed_id:"",},per_page: 50,page:1}
                this.start_time = "";
                this.end_time = "";
                this.getList()
            },
            selectChange(row){
                this.selectList=row;
            },
            del(id){
                this.pl(id)
            },
            edit(id){
                // this.editForm.id = id;
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.editForm = JSON.parse(JSON.stringify(item))
                        this.editDialog = true;
                    }
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time = this.formatTimeZero(this.start_time)
                this.params.search.end_time = this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.settlement.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.totalObj = res.data.data.statistics;
                    this.list.forEach((item)=>{
                        item.processing_time = this.formatTime(item.processing_time*1000)
                        if(item.status==1){
                            item.baseColor="#ff0000"
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            }
        },
         watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "settlementDialog":function(val){
                if(!val){
                    this.settlementDetail = {fee_list:[{amount:"",breed:"",cube:"",name:"",price:""}],plant_name: "",processing_no: "",processing_time: "",total_amount: "",is_invoice:false}
                    this.settlementDetail.is_invoice = false;
                }
            },
            "editDialog":function(val){
                if(!val){
                    this.editForm = this.resetJson(this.editForm)
                }
            }
        }
    }
</script>
